import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminRoute = ({ user, authReady = true, children }) => {
    if (!authReady) {
        return null;
    }

    if (!user) {
        return <Navigate to="/signin" replace />;
    }

    if (user.role !== 'administrator') {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default AdminRoute;
